function qv_attachEvents(){
    $('.quickview').each(function () {
        if(!$(this).hasClass('qv_attached')){
            $(this).click(function (e) {
                e.preventDefault();
                let target = $($(this).data('target'));
                $('#productModal').html(target.html());
                $('#productModal .quickview-img').attr('src', $('#productModal .quickview-img').data('src'));
                $('#productModal').modal('show');
            })
            $(this).addClass('qv_attached')
        }
    });
}
$(document).ready(function () {
    setTimeout(function () {
        qv_attachEvents();
    },400);

    window.addEventListener('resize', checkQuickView);

    function checkQuickView() { 
        let viewPortWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0); 

        if (viewPortWidth <= 1024) { 
            $('#productModal').modal('hide'); 
        } 
    } 
});
